import React from 'react'
import Episode from './Episode'

import type { VideoSectionProps } from './types'
import FocusableLink from '../../components/FocusableLink'

const VideoSection = (props: VideoSectionProps) => {
  const section = props.section

  return (
    <div className="season-content__video-section">
      <h4 className="season-content__video-section__title">{section.title}</h4>
      <div className="season-content__video-section__list">
        {section.videos.length > 0 ? (
          section.videos.map((video, index) => (
            <Episode
              key={video.cid}
              video={video}
              onFocus={props.onFocus}
              extraProps={{
                index:
                  props.sectionIndex === 1
                    ? index + props.firstSectionLength
                    : index,
                section,
                sectionIndex: props.sectionIndex,
                firstSectionLength: props.firstSectionLength,
                video,
              }}
            />
          ))
        ) : (
          <FocusableLink
            className="season-content__video-section__empty-list"
            onFocus={props.onFocus}
            extraProps={{
              index: 0,
              section,
              firstSectionLength: props.firstSectionLength,
              sectionIndex: props.sectionIndex,
            }}
          >
            No <span className="lower-case">{section.title}</span> are currently
            available for this season.
          </FocusableLink>
        )}
      </div>
    </div>
  )
}

export default VideoSection
